import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '../lib/api';

const ContentContext = createContext({ content: {}, reload: () => {} });

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/content');
      setContent(data || {});
    } catch (err) {
      console.error('Failed to load CMS content:', err);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <ContentContext.Provider value={{ content, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
